export enum VendorInventoryType {
    PJ = 1,
    Vendor = 2
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/VendorInventoryType.ts